<template>
  <div class="select-question">
    <div class="controls">
      <textbook-category-select
        :key="courseTypeCode + '-' + categoryCode + '-' + textbookVersion"
        :course-type-code="courseTypeCode"
        :category-code="categoryCode"
        :version="textbookVersion"
        @change="selectLevels"
      />

      <el-form
        ref="form"
        class="search-form"
        label-width="80px"
      >
        <el-form-item label="教材">
          <el-cascader
            ref="selectTextbookCascader"
            v-model="levelAndUnitAndLesson"
            clearable
            filterable
            style="width: 80%;"
            :props="levelsSelectionProps"
            :options="query.levels"
            @change="selectTextbooks"
          >
            <template slot-scope="{ node, data }">
              <span style="float: left">{{ data.name }}</span>
              <span
                v-if="data.isUsed === 0"
                style="color: #8492a6; font-size: 13p"
              >（{{ $t("禁用") }}）</span>
            </template>
          </el-cascader>
        </el-form-item>

        <el-row>
          <el-col :span="12">
            <el-form-item label="能力版块">
              <el-select
                v-model="query.board"
                filterable
                clearable
              >
                <el-option
                  v-for="item in query.boards"
                  :key="item"
                  :label="item"
                  :value="item"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="知识版块">
              <el-select
                v-model="query.training"
                filterable
                clearable
              >
                <el-option
                  v-for="item in query.trainings"
                  :key="item"
                  :label="item"
                  :value="item"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="题型">
              <el-select
                v-model="query.questionType"
                filterable
                clearable
              >
                <el-option
                  v-for="(name, type) in query.qyestionTypes"
                  :key="type"
                  :label="name"
                  :value="type"
                />
              </el-select>
            </el-form-item>

            <el-form-item
              v-if="false"
              label="考核点"
            >
              <el-select
                v-model="query.pointId"
                filterable
                remote
                reserve-keyword
                placeholder="请输入关键词"
                :remote-method="queryKnowledge"
              >
                <el-option
                  v-for="item in query.knowledges"
                  :key="item.uuid"
                  class="points-option"
                  :label="
                    item.word_name ||
                      item.sentence_en ||
                      item.phonic_name ||
                      item.name_en ||
                      item.grammar_level_en ||
                      item.sentence_structure
                  "
                  :value="item.uuid"
                >
                  <template
                    v-if="item.type == 'sentence' && item.sentence_en_answer"
                  >
                    <!-- 问答的对话句子 -->
                    <div style="float: left;">
                      <div>{{ item.sentence_en + ":" + item.sentence_cn }}</div>
                      <div>
                        {{
                          item.sentence_en_answer +
                            ":" +
                            item.sentence_cn_answer
                        }}
                      </div>
                    </div>
                    <span
                      style="float: right; color: #8492a6; font-size: 13px"
                    >{{ item.type }}</span>
                  </template>
                  <template v-else>
                    <template v-if="item.type == 'sentence'">
                      <!-- 普通的句子 -->
                      <span style="float: left; line-height:60px !important;">{{
                        item.sentence_en + ":" + item.sentence_cn
                      }}</span>
                      <span
                        style="float: right; color: #8492a6; font-size: 13px"
                      >{{ item.type }}</span>
                    </template>
                    <template v-else-if="item.type == 'word'">
                      <span style="float: left; line-height:60px !important;">{{
                        item.word_name + ":" + item.meaning_of_kid
                      }}</span>
                      <span
                        style="float: right; color: #8492a6; font-size: 13px"
                      >{{ item.type }}</span>
                    </template>
                    <template v-else-if="item.type == 'phonic'">
                      <span style="float: left; line-height:60px !important;">{{
                        item.phonic_name
                      }}</span>
                      <span
                        style="float: right; color: #8492a6; font-size: 13px"
                      >{{ item.type }}</span>
                    </template>
                    <template v-else-if="item.type == 'grammar_level'">
                      <span style="float: left; line-height:60px !important;">{{
                        item.grammar_level_en + " : " + item.grammar_level
                      }}</span>
                      <span
                        style="float: right; color: #8492a6; font-size: 13px"
                      >{{ item.type }}</span>
                    </template>
                    <template
                      v-else-if="
                        item.type == 'reading_strategy' ||
                          item.type == 'reading_style'
                      "
                    >
                      <span style="float: left; line-height:60px !important;">{{
                        item.name_en + " : " + item.name_cn
                      }}</span>
                      <span
                        style="float: right; color: #8492a6; font-size: 13px"
                      >{{ item.type }}</span>
                    </template>
                    <template v-else-if="item.type == 'sentence_structure'">
                      <span style="float: left; line-height:60px !important;">{{
                        item.sentence_structure + " : " + item.meaning
                      }}</span>
                      <span
                        style="float: right; color: #8492a6; font-size: 13px"
                      >{{ item.type }}</span>
                    </template>
                  </template>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="search()"
          >
            搜索
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="questions">
      <el-table
        ref="questionsTable"
        :data="questions"
        style="width: 100%;"
        @selection-change="questionSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
        />

        <el-table-column
          label="题型"
          width="150"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.type | questionType }}</span>
          </template>
        </el-table-column>

        <el-table-column label="内容梗概(文本、图片、音频等)">
          <template slot-scope="scope">
            <question-content
              :key="scope.row.uuid"
              :question="scope.row"
            />
          </template>
        </el-table-column>

        <el-table-column label="考核点">
          <template slot-scope="scope">
            <question-point
              :key="scope.row.uuid"
              :question="scope.row"
            />
          </template>
        </el-table-column>

        <el-table-column
          label="答案"
          width="90"
        >
          <template slot-scope="scope">
            <question-answer
              :key="scope.row.uuid"
              :question="scope.row"
            />
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="operate">
      <el-button
        type="primary"
        size="small"
        @click="select()"
      >
        确定
      </el-button>
      <el-button
        size="small"
        @click="$emit('close')"
      >
        取消
      </el-button>
    </div>
  </div>
</template>

<style lang="less" scoped>
.search-form {
  .el-input,
  .el-select {
    width: 80%;
  }
}
.operate {
  margin-top: 40px;
}

.points-option {
  height: 66px !important;
}
</style>

<script>
const debug = require('debug')('ccs:component:select-question');
import { pick, isNil } from 'lodash';
import { questionParse } from '../utils/index';
import questionContent from './question_content';
import questionAnswer from './question_answer';
import questionPoint from './question_point';
import textbookCategorySelect from './textbook_category_select';
import { BOARDS, TRAININGS, QUESTION_TYPES } from '../constants';
import axios from 'axios';

export default {
	components: {
		questionContent,
		questionAnswer,
		questionPoint,
		textbookCategorySelect
	},
	props: {
		categoryId: [String],
		levelId: [Number, String],
		unitId: [Number, String],
		lessonId: [Number, String],
		selected: {
			type: Array,
			default: () => []
		},
		standard: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			// 级联配置
			levelsSelectionProps: {
				lazy: true,
				checkStrictly: true,
				value: 'id',
				label: 'name',
				expandTrigger: 'hover',
				lazyLoad(node, resolve) {
					if (this.categoryId === 'upgrade') {
						return resolve();
					}
					if (node.value) {
						const { value: textbookId, level } = node;
						axios
							.get(`/api/textbooks/${textbookId}/child`, {
								params: {
									fields: 'id,name,nameEnUs,nameZhCn,isUsed'
								}
							})
							.then(textbooks => {
								// 判断级别
								textbooks.forEach(item => item.leaf = level + 1 >= !this.categoryId ? 2 : 3);
								resolve(textbooks);
							})
							.catch(() => resolve());
					} else {
						resolve();
					}
				}
			},

			courseTypeCode: null,
			categoryCode: null,
			textbookVersion: null,
			levelAndUnitAndLesson: [],

			query: {
				categoryId: null,
				levelId: null,
				unitId: null,
				lessonId: null,
				board: null,
				training: null,
				questionType: null,
				pointId: null,

				//单元测试的知识板块
				knowledges: [],
				levels: [],
				units: [],
				lessons: [],
				boards: BOARDS,
				//单元测试的能力板块
				trainings: TRAININGS,
				qyestionTypes: QUESTION_TYPES,
        
				standard: null,
			},

			questions: [],
			questionSelection: []
		};
	},
	async created() {
		await this.init();
	},
	methods: {
		async init() {
			this.query.categoryId = this.categoryId;
			this.query.levelId = this.levelId;
			this.query.unitId = this.unitId;
			this.query.lessonId = this.lessonId;
			this.query.standard = this.standard || '';
			await this.search();

			// 初始化
			let lesson, unit, level, courseTypeCode, categoryCode, textbookVersion;
			if (this.lessonId) {
				lesson = await axios.get(`/api/textbooks/${this.lessonId}`, {
					params: {
						fields: 'id,name,treePath,version,categoryCode,courseTypeCode'
					}
				});
				courseTypeCode = lesson.courseTypeCode;
				categoryCode = lesson.categoryCode;
				textbookVersion = lesson.version;

				const [_, levelId, unitId] = lesson.treePath;
				this.levelId = levelId;
				this.unitId = unitId;
			}
			if (this.unitId) {
				unit = await axios.get(`/api/textbooks/${this.unitId}`, {
					params: {
						fields: 'id,name,treePath,version,categoryCode,courseTypeCode'
					}
				});
				courseTypeCode = unit.courseTypeCode;
				categoryCode = unit.categoryCode;
				textbookVersion = unit.version;

				const [_, levelId] = unit.treePath;
				this.levelId = levelId;
			}
			if (this.levelId) {
				level = await axios.get(`/api/textbooks/${this.levelId}`, {
					params: {
						fields: 'id,name,treePath,version,categoryCode,courseTypeCode'
					}
				});
				courseTypeCode = level.courseTypeCode;
				categoryCode = level.categoryCode;
				textbookVersion = level.version;
			}

			debug(
				'[init] courseTypeCode: %s, categoryCode: %s, textbookVersion: %s, levelId: %s, unitId: %s, lessonId: %s',
				courseTypeCode,
				categoryCode,
				textbookVersion,
				this.levelId,
				this.unitId,
				this.lessonId
			);

			this.courseTypeCode = courseTypeCode;
			this.categoryCode = categoryCode;
			this.textbookVersion = textbookVersion;
			this.levelAndUnitAndLesson = [
				this.levelId,
				this.unitId,
				this.lessonId
			].filter(val => !!val);

			try {
				const textbooks = [];
				if (level) textbooks.push(level.name);
				if (unit) textbooks.push(unit.name);
				if (lesson) textbooks.push(lesson.name);

				if (textbooks.length > 0) {
					this.$refs.selectTextbookCascader.$el.querySelector(
						'.el-cascader > .el-input > input'
					).value = textbooks.join(' / ');
				}
			} catch (ignored) {}
		},

		async selectLevels(levels) {
			debug('[selectLevels] levels: %o', levels);
			this.query.levels = levels;
		},

		async selectTextbooks() {
			const [levelId, unitId, lessonId] = this.levelAndUnitAndLesson;
			this.query.levelId = levelId;
			this.query.unitId = unitId;
			this.query.lessonId = lessonId;
		},

		questionSelectionChange(selected) {
			debug('[questionSelectionChange] selected: %o', selected);
			this.questionSelection = selected;
		},

		async search(query = {}) {
			let urlPath = '/api/ut/questions';
			if (this.query.categoryId && ['preview'].includes(this.query.categoryId)) {
				urlPath = `/api/${this.query.categoryId}/questions`;
			}
			if (this.query.categoryId && ['review'].includes(this.query.categoryId)) {
				urlPath = `/api/${this.query.categoryId}/questions`;
			}
			if (this.query.categoryId && ['langtest'].includes(this.query.categoryId)) {
				urlPath = `/api/${this.query.categoryId}/questions`;
			}
			if (this.query.categoryId && ['upgrade'].includes(this.query.categoryId)) {
				urlPath = '/api/up/questions';
			}
			console.log(urlPath,this.query,'urlPath'); // eslint-disable-line
			const questions = await axios.get(urlPath, {
				params: Object.assign(
					pick(this.query, [
						'levelId',
						'unitId',
						'lessonId',
						'questionType',
						'board',
						'training',
						'pointId',
						'standard'
					]),
					query
				)
			});

			this.questions = questionParse(...questions);

			// 初始化勾选
			this.selected.forEach(row1 => {
				this.questions.forEach(row => {
					if (row1.uuid === row.uuid) {
						this.$nextTick(() => {
							this.$refs.questionsTable.toggleRowSelection(row, true);
						});
					}
				});
			});
		},

		select() {
			debug('[select] questionSelection: %o', this.questionSelection);
			this.$emit('close', this.questionSelection);
		},

		async queryKnowledge(keyword) {
			if (!keyword) return;
			this.query.knowledges = await axios.get('/api/ut/knowledge', {
				params: {
					keyword
				}
			});
		}
	}
};
</script>